module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/19b5f6627a8e68005c44273cf1702ed5.png";